import * as React from "react";
import {Loader} from "../../../components/Utils/loader/Loader";
import {Display} from "../../../components/Display";
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import {Legend} from "../../../components/charts/Legend";
import {EmptyState, icons, infoIcons} from "@vebox/etui-core";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {PieChartWithLabels, PieChartWithLabelsRow} from "../../../dashboard/widgets/charts/PieChartWithLabels";
import {DATA_STATE, useUserDashboardData} from "../../contexts/UsersDashboardContext";
import AutoSizer from "react-virtualized-auto-sizer";


declare var AppTranslations: AppTranslations;

export interface ActiveUsersResponse {
    numberOfActiveUser: number,
    numberOfInactiveUser: number

}

interface LegendItem {
    color: string,
    name: string,
    value: number,
    percentage: number
}

export interface ActiveUsersStats {
    items: PieChartWithLabelsRow[]
    total: number;
}


const getPieChartLegend = (usersStats: ActiveUsersStats): LegendItem [] => {
    return usersStats.items.map((item) => {
            const percentage = (item.frequency * 100) / usersStats.total
            return {
                color: item.color,
                name: item.label,
                value: item.frequency,
                percentage,
            };
        },
    );
}

export const ActiveUsers: React.FC = () => {

    const [isEmpty, setIsEmpty] = React.useState(false);
    const [selectedItem, setSelectedItem] = React.useState();
    const {usersStats, state} = useUserDashboardData().activeUsersState;
    const [legendItems, setLegendItems] = React.useState<LegendItem[]>([]);


    React.useEffect(() => {
        if (usersStats && state === DATA_STATE.loaded) {
            if (usersStats.total > 0) {
                setLegendItems(getPieChartLegend(usersStats))
                setIsEmpty(false);
            } else {
                setIsEmpty(true)
            }
        }
    }, [usersStats]);

    return (
        <VeBoxCard className={"Section"}>
            <VeBoxCard.Header
                title={AppTranslations.usersManagement.usersStatusTitle}
                singleLineTitle={true}
                className={"padding-bottom-13 padding-top-13"}
            />
            <VeBoxCard.Body className={"detail-card"}>
                <Display isVisible={state === DATA_STATE.isLoading}>
                    <Loader/>
                </Display>
                <Display isVisible={state === DATA_STATE.loaded}>
                    <Display isVisible={!isEmpty}>
                        <div className="widget-content">
                            <div className="user-management-chart-legend">
                                <Legend
                                    items={legendItems}
                                    selectedItemName={selectedItem}
                                    onItemHover={setSelectedItem}
                                    showValues={true}
                                />
                            </div>
                            <AutoSizer style={{width: "auto"}}>
                                {({width}) => (
                                    <PieChartWithLabels
                                        data={usersStats ? usersStats.items : []}
                                        selectedItem={selectedItem}
                                        onPathOver={setSelectedItem}
                                        height={400}
                                        width={width}
                                        donutOptions={{activeDonut: true}}
                                        showPercentage={true}
                                        showIcon={false}
                                        labelLineDefaultLength={30}
                                        labelsOptions={{externalLegend: true}}
                                        noDataMessage={AppTranslations.noDataAvailable}
                                        radiusRatio={2}
                                    />
                                )}
                            </AutoSizer>
                        </div>
                    </Display>
                    <Display isVisible={isEmpty}>
                        <div className={"vertical-align-center"}>
                            <EmptyState>
                                <EmptyState.InfoIcon
                                    styles={{
                                        root: {
                                            color: "var(--empty-indicator-svg-stroke)",
                                        }
                                    }}
                                    glyph={infoIcons.NoContent}
                                />
                                <EmptyState.Title color="var(--empty-indicator-title-color)">{AppTranslations.noDataAvailable}</EmptyState.Title>
                                <EmptyState.SubTitle color="var(--empty-indicator-subtitle-color)">{AppTranslations.miscellaneous.checkFiltersMessage}</EmptyState.SubTitle>
                            </EmptyState>
                        </div>
                    </Display>
                </Display>
                <Display isVisible={state === DATA_STATE.error}>
                    <EmptyState>
                        <EmptyState.Icon size={144} glyph={icons.ERROR_CIRCLE}/>
                        <EmptyState.Title color="var(--empty-indicator-title-color)">{AppTranslations.errorMessages.errorTitle}</EmptyState.Title>
                        <EmptyState.SubTitle color="inherit">
                            {AppTranslations.errorMessages.tryAgainLaterMessage}
                        </EmptyState.SubTitle>
                    </EmptyState>
                </Display>
            </VeBoxCard.Body>
        </VeBoxCard>
    )
}